import BlogPage from "../components/BlogPage.js"
import { BASE_ASSETS_URL } from "../utils/constants.js"

const SheepPage = ({ text }) => {
    const blogPosts = [{
        key: "villnoesser-brillenschaf-intro",
        title: text.villnoesserBrillenschafTitle,
        subtitle: text.villnoesserBrillenschafSubtitle,
        body: text.villnoesserBrillenschafBody,
        images: [
            {
                url: `${BASE_ASSETS_URL}images/sheep_guenther_2.jpg`,
                size: "lg",
                alt: "Günther Messner feeding sheep"
            },
            {
                url: `${BASE_ASSETS_URL}images/sheep_grass_1.jpg`,
                size: "lg",
                alt: "Sheep on meadow"
            }
        ]
    }]

    //TODO: trim image of sheep
    return (
        <div className="drocker-body">
            <div className="position-relative">
                <div className="drocker-responsive-image" style={{ backgroundImage: `url(${BASE_ASSETS_URL}images/sheep_garden_1.jpg)` }}></div>
                <div className="container drocker-h1-container">
                    <h1 className="text-white mb-0 drocker-title-outline">{text.sheepTitle}</h1>
                </div>
            </div>
            <div className="container">
                <BlogPage text={text} blogPosts={blogPosts} />
            </div>
        </div>
    )
}

export default SheepPage
